import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { HowItWorks } from "../components/site/HowItWorks";
import { Packages } from "../components/site/Packages";
import { Gallery } from "../components/site/Gallery";
import { Coverage, Faq } from "../components/site/Faq";
import { FinalCta, Footer, WhatsAppFab } from "../components/site/Footer";
import { scrollToId } from "../components/site/SmoothScroll";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 300);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <HowItWorks />
      <Packages />
      <Gallery />
      <Coverage />
      <Faq />
      <FinalCta />
      <Footer />
      <WhatsAppFab />
    </main>
  );
}
